class Athos {
  // Products tagged with the Athos exclude tag are returned with ss_exclude: 'yes',
  // so only requesting ss_exclude: 'no' keeps them out of every Athos response.
  static EXCLUDE_FILTER = { field: 'ss_exclude', value: 'no', type: 'value', background: true };

  constructor() {
    this.init();
  }

  init() {
    const isEnabled = this.isEnabled();

    if (!isEnabled) {
      return;
    }

    this.initGlobalsControllerServices();
  }

  initGlobalsControllerServices() {
    const { merchandising } = SnapCore.getContext(['merchandising']);

    const siteId = window.athosVariables.siteId;

    this.client = new SnapCore.Client(
      {
        siteId,
        merchandising: {
          segments: merchandising?.segments || []
        },
      }
    );

    this.tracker = new SnapCore.Tracker({ siteId });
  }

  isEnabled() {
    return window.athosVariables?.siteId ? true : false;
  }

  // Applied to the controller config so the exclusion covers the search, category and
  // autocomplete APIs from a single place. Recommendations are skipped because the
  // recommendation index does not return ss_exclude yet, so filtering on it there
  // returns no results - those are excluded in product-cards.liquid instead.
  applyExcludeFilter(type, config = {}) {
    if (!window.athosVariables?.excludeTaggedProducts || type === 'recommendations') {
      return config;
    }

    config.globals = config.globals || {};
    config.globals.filters = config.globals.filters || [];

    const alreadyApplied = config.globals.filters.some((filter) => filter.field === Athos.EXCLUDE_FILTER.field);
    if (!alreadyApplied) {
      config.globals.filters = [...config.globals.filters, Athos.EXCLUDE_FILTER];
    }

    return config;
  }

  initController(type, config) {
    config = this.applyExcludeFilter(type, config);

    switch (type) {
      case 'recommendations':
        const recommendationUrlManager = new SnapCore.UrlManager(new SnapCore.UrlTranslator(), SnapCore.reactLinker).detach(0);

        return new SnapCore.RecommendationController(config, {
            client: this.client,
            store: new SnapCore.RecommendationStore(config, { urlManager: recommendationUrlManager }),
            urlManager: recommendationUrlManager,
            eventManager: new SnapCore.EventManager(),
            profiler: new SnapCore.Profiler(),
            logger: new SnapCore.Logger(),
            tracker: this.tracker,
          }
        );

      case 'autocomplete':
        const autocompleteUrlManager = new SnapCore.UrlManager(new SnapCore.UrlTranslator(), SnapCore.reactLinker).detach();

        return new SnapCore.AutocompleteController(config, {
            client: this.client,
            store: new SnapCore.AutocompleteStore(config, { urlManager: autocompleteUrlManager }),
            urlManager: autocompleteUrlManager,
            eventManager: new SnapCore.EventManager(),
            profiler: new SnapCore.Profiler(),
            logger: new SnapCore.Logger(),
            tracker: this.tracker,
          }
        );

      case 'collection':
        const searchUrlManager = new SnapCore.UrlManager(new SnapCore.UrlTranslator(), SnapCore.reactLinker);

        return new SnapCore.SearchController(config, {
            client: this.client,
            store: new SnapCore.SearchStore(config, { urlManager: searchUrlManager }),
            urlManager: searchUrlManager,
            eventManager: new SnapCore.EventManager(),
            profiler: new SnapCore.Profiler(),
            logger: new SnapCore.Logger(),
            tracker: this.tracker,
        });
    }
  }

  async fetchProducts(productHandles, style = 'standard', currentPage = 1) {
    const batchLimit = 20;
    const batches = Math.ceil(productHandles.length / batchLimit);
    const batchResults = new Array(batches);

    const fetchPromises = [];

    for (let i = 0; i < batches; i++) {
      const start = i * batchLimit;
      const end = start + batchLimit;
      const batchHandles = productHandles.slice(start, end);
      const variantParameterValue = Math.floor(Date.now() * Math.random());

      const fetchPromise = fetch(`${window.Shopify.routes.root}?section_id=product-cards&card-style=${style}&product_handles=${batchHandles.join(',')}&variant=${variantParameterValue}&current_page=${currentPage}&batch=${i + 1}&batch_limit=${batchLimit}`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const productCards = html.querySelectorAll('[data-product-cards] [data-product-card-wrapper]');

          batchResults[i] = [...productCards];
        })
        .catch(e => {
          console.error(e);
        });

      fetchPromises.push(fetchPromise);
    }

    await Promise.all(fetchPromises);

    return batchResults.flat();
  }
}

const athos = new Athos();
